import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";

let dayOfWeek = [];
let hours = [];
let dimension;
const barChartFunc = (divRef, ndx) => {
  const myChart = dc.heatMap(divRef);
  dimension = ndx.dimension(function (d) {
    var day = +d.day;
    //console.log(day)
    dayOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    hours = ["1a", "2a", "3a", "4a", "5a", "6a", "7a", "8a", "9a", "10a", "11a", "12a", "1p", "2p", "3p", "4p", "5p", "6p", "7p", "8p", "9p", "10p", "11p", "12p"];
    var hour = +d.hour;
    //console.log([dayOfWeek[day],  hours[hour]]);
    return [day, hour];//day + '.' + name[day];
  });
  const group = dimension.group()  //.reduceSum(function(d) { return +d.count; })
  .reduce(
    function(p, v) { // add
      ++p.count;
      if(p.count > 0) {
        p.total += parseFloat(v.wait_time);
        p.avg = parseFloat(p.total/p.count);
        p.tot_conversation_time += parseFloat(v.conversation_time);
        p.avg_conversation_time = parseFloat(p.tot_conversation_time/p.count);
      }
      else {
        p.avg = 0;
        p.total = 0;
        p.tot_conversation_time = 0;
        p.avg_conversation_time = 0;
      }
      return p;
    },
    function(p, v) { // remove
      --p.count;
      if(p.count > 0) {
        p.total -= parseFloat(v.wait_time);
        p.avg = parseFloat(p.total/p.count);
        p.tot_conversation_time -= parseFloat(v.conversation_time);
        p.avg_conversation_time = parseFloat(p.tot_conversation_time/p.count);
      }
      else {
        p.avg = 0;
        p.total = 0;
        p.tot_conversation_time = 0;
        p.avg_conversation_time = 0;
      }
      return p;
    },
    function() { // init
        return {count: 0, total: 0, avg: 0, tot_conversation_time: 0, avg_conversation_time: 0};
    }
  );

  // function filter_bins(source_group, f) {
  //   return {
  //     all: function() {
  //       return source_group.all().filter(function(d) {
  //         return f(d.value);
  //       });
  //     }
  //   };
  // }
  //
  // const filtered_days_group = filter_bins(group, function(d) {
  //   const days = yearSlicer.filters();
  //   return years.length ? years.includes(d.Year) : true;
  // });


  myChart
  .title('heatmap')
  .dimension(dimension)
  .group(group)
  .colsLabel(function(d) { return hours[d]; })
  .rowsLabel(function(d) { return dayOfWeek[d];  })
  .keyAccessor(function(d) { return +d.key[1]; })
  .valueAccessor(function (d) {return +d.key[0]; })
  .colorAccessor(function(d) { return +d.value.count; })


  .margins({ top: 5, right: 15, bottom: 25, left: 50 })
  .title(function(d) {
    return "Day:   " + dayOfWeek[d.key[0]] + "\n" +
           "Hour:  " + hours[d.key[1]] + "\n" +
           '# of Conversations:  ' + Math.floor(+d.value.count* 100) / 100 + "\n" +
           "Total Waiting Time:  " + Math.floor(+d.value.total) + " secs.\n" +
           "Avg Waiting Time:  " + Math.floor(+d.value.avg* 100) / 100 + " secs.\n" +
           "Total Converastion Time:  " + Math.floor(+d.value.tot_conversation_time) + " secs.\n" +
           "Avg Converastion Time:  " + Math.floor(+d.value.avg_conversation_time* 100) / 100 + " secs.";})
  .transitionDuration(1000)
  .colors(['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c',' #08306b'])
  .calculateColorDomain()
  .on('preRedraw', function() {
       myChart.calculateColorDomain();
   })

  return myChart
}

  export class HeatMap extends React.Component {
    constructor(props) {
    super(props);
  }

  get theDimension() {
    return dimension;
  }

  render() {
    return (
      <ChartTemplate chartFunction={barChartFunc} title={this.props.title}
      dim={this.props.dim} type={this.props.type}/>
    );
  }
}
